"use client";

import { FC } from "react";
import dynamic from "next/dynamic";

import { useStyles } from "./styles";
import { useAppSelector } from "@/redux/store";
import ForYou from "./ForYou";
import GenerateImages from "./GenerateImages";
import Quiz from "./Quiz";
import Dictionary from "./Dictionary";
import Monetization from "./Monetization";
import Divider from "@/components/common/Divider";
// import DynamicAd from "@/components/adverts/DynamicAd";

const PreviewGallery = dynamic(() => import("./PreviewGallery"));

interface SidebarContentProps {
  closeDrawer?: () => void;
}

const SidebarContent: FC<SidebarContentProps> = ({ closeDrawer }) => {
  const { classes } = useStyles();
  const isAuthenticated = useAppSelector((state) => state.user.isAuthenticated);

  const handleCloseDrawer = () => {
    if (closeDrawer) {
      closeDrawer();
    }
  };

  return (
    <div className={classes.content}>
      <div className={classes.contentInner}>
        <ForYou onClose={handleCloseDrawer} />
        <GenerateImages onClose={handleCloseDrawer} />
        <Quiz onClose={handleCloseDrawer} />
        <Dictionary onClose={handleCloseDrawer} />
        <Monetization />
        <Divider marginTop={6} marginBottom={0} />
        {isAuthenticated ? (
          <PreviewGallery onClose={handleCloseDrawer} />
        ) : (
          <div className={classes.contentInnerPlaceholder}>
            {/* <DynamicAd variant="sticky-sidebar" /> */}
          </div>
        )}
      </div>
    </div>
  );
};

export default SidebarContent;
